import { Colors } from 'shared/theme/colors'
import styled from 'styled-components'

import { Button } from './Button'
import { ButtonInner, ButtonOuter, ButtonPadding } from './Button.styles'

/** Consistent 40px actions for operational screens and dialogs. */
export const ActionButton = styled(Button).attrs({ size: 'medium' })`
  box-sizing: border-box;
  min-height: 40px;
  height: auto;
  max-width: 100%;
  min-width: min-content;
  flex-shrink: 0;
  padding: 8px 14px;
  font-size: 14px;
  line-height: 20px;
  transition:
    background-color 150ms ease,
    border-color 150ms ease,
    color 150ms ease;

  ${ButtonOuter} {
    display: flex;
    min-width: 0;
  }

  ${ButtonPadding} {
    display: none;
  }

  ${ButtonInner} {
    white-space: normal;
    overflow-wrap: break-word;
  }

  &:focus-visible {
    outline: 2px solid ${Colors.royalBlue};
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`
